import * as next from '../../../types/next'
import { CONTROL_NAME } from '../../../utils'
import type { UpBlockHandler } from '../types'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.PaymentMethodBlock> = (uischema) => {
  if (uischema.type !== CONTROL_NAME.PAYMENT_CONTROL) {
    throw new Error('Expected a valid PaymentMethod control')
  }

  return {
    type: next.BLOCK_TYPE.PAYMENT_METHOD,
    required: false, // can never be required
    settings: {
      ...upCommonSettings(uischema),
      inputUIPattern: uischema.options?.uiType,
      preselectedMethod: uischema.options?.initialType,
      implementations: upPaymentMethodImplementations(
        uischema.options?.implementations
      )
    }
  }
}
function upPaymentMethodImplementations(
  implementations: any
): next.PaymentMethodImplementation[] {
  const implementationsV4: next.PaymentMethodImplementation[] = []

  implementations.forEach((implementation: any) => {
    implementationsV4.push({
      type: implementation.type,
      label: implementation.label,
      display: implementation.show,
      // componentProps should only be available when type is SEPA
      settings: implementation.componentProps
        ? ({
            validationMessages: {
              accountOwner:
                implementation.componentProps.accountOwnerNameHelper,
              accountNumber: implementation.componentProps.ibanHelper
            },
            fieldLabels: {
              accountOwner: implementation.componentProps.accountOwnerNameLabel,
              bankName: implementation.componentProps.bankNameLabel,
              consentLabel: implementation.componentProps.consentLabel
            },
            accountNumberValidationURL: implementation.componentProps.apiBaseUrl
          } as next.SEPAImplementationSettings)
        : undefined
    } as next.PaymentMethodImplementation)
  })

  return implementationsV4
}
